type IsIFrame = () => boolean;
export const isIFrame: IsIFrame = () => window.top !== window.self;
